import { Divider } from '@ets/design-system';

import { useSelector } from '_common/hooks';

import IntlErrorBoundary from '../IntlErrorBoundary/IntlErrorBoundary';
import LogoContainer from '../LogoContainer/LogoContainer';
import ChangeTenantDropdown from './ChangeTenantDropdown/ChangeTenantDropdown';
import Navigation from './Navigation/Navigation';
import Options from './Options/Options';

import styles from './Sidebar.module.scss';
import { InteractionController } from '_common/components';

const SidebarContent = () => {
  const sidebarExpanded = useSelector((state) => state.sidebar.expanded);

  return (
    <>
      <InteractionController
        environment="explorer"
        style={{ height: '100%', flexDirection: 'column' }}
      >
        <IntlErrorBoundary
          variant="white"
          size="s"
          style={{ margin: '4rem auto 1rem auto' }}
          collapsed={!sidebarExpanded}
        >
          <div style={{ height: '12rem', display: 'flex', alignItems: 'center' }}>
            <LogoContainer expanded={sidebarExpanded} color="white" testId="sidebar-logo" />
          </div>
        </IntlErrorBoundary>
        <div className={styles.content} id="ExplorerSidebarContent">
          <IntlErrorBoundary
            variant="white"
            size="s"
            style={{ margin: '5rem auto 1rem auto' }}
            collapsed={!sidebarExpanded}
            tooltipSide="left"
          >
            <ChangeTenantDropdown />
          </IntlErrorBoundary>
          <IntlErrorBoundary
            variant="white"
            size={sidebarExpanded ? 'l' : 's'}
            style={{
              margin: '6.5rem auto 0 auto',
              flexDirection: 'column',
              gap: '2rem',
              alignItems: 'center',
            }}
            collapsed={!sidebarExpanded}
            tooltipSide="left"
          >
            <Navigation />
          </IntlErrorBoundary>
          <Divider variant="dark" margin="auto 0 1rem 0" />
          <IntlErrorBoundary
            variant="white"
            size={sidebarExpanded ? 'l' : 's'}
            style={{
              margin: '4rem auto',
              flexDirection: 'column',
              gap: '2rem',
              alignItems: 'center',
            }}
            collapsed={!sidebarExpanded}
            tooltipSide="left"
          >
            <Options />
          </IntlErrorBoundary>
        </div>
      </InteractionController>
    </>
  );
};

export default SidebarContent;
